import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import saveAs from 'file-saver';
import { useNavigate } from 'react-router-dom'
import cssclass from "./cssclass";
//var dateFormat = require('dateformat');

	

const Rendervoucher = () => {

const resturl=sessionStorage.getItem("RESTURL");
let customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const [modal, setModal] = useState({open:false});
const navWpform = React.useRef();


const [mpenameopts, setMpenameopts] = useState([]);
const [tblvoucher, setTblvoucher] = useState([]);
const [arrayvoucher, setArrayvoucher] = useState([]);
const [tblwptappudakimport, setTblwptappudakimport] = useState([]);

const [importdate, setImportdate] = useState({count:0});
const [wptapp, setWptapp] = useState({});
const [dowait, setDowait] = useState({show:false});

const [crit, setCrit] = useState({
	DOC_NO:''
	, DOC_DATE:  ''
	, DOC_AMT:  ''
	, DOC_COMMENT: ''
	});



const location = useLocation();


useEffect(() => {

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if

document.title =   "Add Recepts";

const MPE_NAME=location.state?(location.state.MPE_NAME??""):"";
const WPT_APP_ID=location.state?(location.state.WPT_APP_ID??0):0;

if (WPT_APP_ID==0)
	window.alert("The Id # for the application is not known");
else
	setWptapp((prev)=>{
	return {...prev, WPT_APP_ID:WPT_APP_ID, MPE_NAME:MPE_NAME}
	});;

 },[]);



useEffect(() => {
	document.getElementsByName('DOC_NO')[0].focus();
	
 },[JSON.stringify(tblvoucher)]);

useEffect(() => {
	if (importdate.count>0)
		cssclass("btnprocess", "hidden", 1);
	
 },[importdate.count]);


useEffect(() => {
	 
	
	 if (wptapp.MPE_NAME!=""){
		let tempopts=[];
		//<option value="JODELYN" key="opt111" >JODELYN</option>
		const arrName=(""+wptapp.MPE_NAME).trim().split(" ");
		
		for (var i=0; i<arrName.length; i++){
			const key="name_opt_"+i;
			const namePart=(""+arrName[i]).trim();
			if (namePart!="")
				tempopts.push(<option value={namePart} key={key} >{namePart}</option>);
			}//end for
			
		
		setMpenameopts(tempopts);
		}//end if
	
	
 },[wptapp.MPE_NAME]);


useEffect(() => {
	 
	 if (wptapp.WPT_APP_ID>0)
		 gettblwptappudakimport();
	
 },[wptapp.WPT_APP_ID]);


 
useEffect(() => {
	 
	 if (arrayvoucher.length>0)
		writetblvoucher();
	else
		setTblvoucher([]);
	
 },[JSON.stringify(arrayvoucher)]);
 

function formatDate(pDate){
	//const d = new Date();
var yyyy = pDate.getFullYear();
var dd = ("0" + pDate.getDate()).slice(-2);
var mm = ("0" + (pDate.getMonth() + 1)).slice(-2);
const resDate = `${yyyy}-${mm}-${dd}`;
console.log("resDate: "+resDate);
return resDate;

}

function subtractMonth(date, months) {
  let d = date.getDate();
  date.setMonth(date.getMonth() - months);
  if (date.getDate() != d) {
    date.setDate(0);
  }
  return date;
}//end func 



function writetblvoucher(){
	//console.log('writetblvoucher: '+JSON.stringify(arrayvoucher));
let htmrows=[];	
	
	for (var index=0; index<arrayvoucher.length; index++){
		const col=arrayvoucher[index];
		const key="tblvchrs_"+index;
		const docNo=col['DOC_NO'];
		//const downloadLink=<a href="#" className="nodecor" id={"link_"+index} onClick={(e)=>{insertdocumlist(e, col);}} ><img src='img/pdf.gif' border='0' />&nbsp;{docNo}</a>;
		const importLink=<a href="#" className="nodecor" title="add receipt numbers" onClick={(e)=>{importwptappdocnum(e, col);}} ><img src="img/add-button.png" height="16" />&nbsp;{docNo}</a>;
		
		const htmrow=<tr key={key} >
					<td align="right" >{index+1}</td>
					<td align="left" >{col['TRANS_DATE']}</td>
					<td align="left" >{importLink}</td>
					<td className="tlnrgt" >{col['AMOUNT']}</td>
					<td align="left" >{col['TC_DATE_PAID']}</td>
					<td align="left" >{col['ACCT_DESCP_1']}</td>
					<td align="left" style={{width:"350px"}} >{col['DOC_COMMENT']}</td>
					<td align="left" >{col['OTHER_PARTY']}</td>
						{/*<td align="left" >{col['RV_COMMENT']}</td>*/}
		</tr>;
		htmrows.push(htmrow);
	}//end if
	
setTblvoucher(htmrows);
	
}//end func

async function gettblwptappudakimport(){
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WPT_APP_ID: wptapp.WPT_APP_ID} )
  };		

setDowait({show:true});
setTblwptappudakimport([]);

 await fetch(resturl+'rarwpform/gettblwptappudakimport',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblwptappudakimport(res) )
      .catch(err => console.log(err));
}//end func

function aftergettblwptappudakimport(res){
	
	setDowait({show:false});
	
if (!res.length)	
	return;
	
let htmrows=[];	
let tempImportdatecount=0;
	
	res.map((col, index) => {
		const key="tblimport_"+index;
		const docNo=col['DOC_NO'];
		const TC_IMPORT_DATE=col.TC_IMPORT_DATE??"";
		if (TC_IMPORT_DATE!="")
			tempImportdatecount+=1
			
		
		const htmrow=<tr key={key} >
					<td align="right" >{index+1}</td>
					<td align="left" ><a href="#" onClick={(e)=>{delwptappudakimport(e, col['SEQ_NO']);}} className="nodecor" ><img src="img/noicon.png" height="16" border="0" />&nbsp;&nbsp;{col['DOC_DATE']}</a></td>
					<td align="left" ><a href="#" onClick={(e)=>{downloadpdfrcp(e);}} className="nodecor" ><img src="img/pdf.gif" border="0" />&nbsp;&nbsp;{col['DOC_NO']}</a></td>
					<td className="tlnrgt" >{col['DOC_AMT']}</td>
					<td align="center" >{col['TC_DATE_PAID']}</td>
					<td align="left" style={{width:"350px"}} >{col['DOC_COMMENT']}</td>
					<td align="center" >{col['TC_IMPORT_DATE']}</td>
					
				</tr>;
		htmrows.push(htmrow);
		});//end map
	
setTblwptappudakimport(htmrows);
setImportdate({count:tempImportdatecount});
}//end func


async function downloadpdfrcp(e){
	e.preventDefault();
	window.alert("Download receipt feature is currently unavailable,\r\nbut you should upload a copy of the paid receipt to the application");
}//end func
	
async function importwptappdocnum(e, col){

e.preventDefault();
	
	e.target.style.visibility='hidden';

	const params={
		USERNAME: sessionStorage.getItem("USERNAME")
		, WPT_APP_ID: wptapp.WPT_APP_ID
		, DOC_NO: col.DOC_NO 
		, UDAK_NO: col.UDAK_NO
	};
	
	console.log("importwptappdocnum: "+JSON.stringify(params));
	//const filename="RCP.pdf";

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

setDowait({show:true});

await fetch(resturl+'rarwpform/importwptappdocnum',requestOptions)
      .then(res => res.json())
      .then(res => 	afterimportwptappdocnum(e, res) )
      .catch(err => console.log(err));
	
}//end func

function afterimportwptappdocnum(e, res){
	e.target.style.visibility='visible';
	setDowait({show:false});
	gettblwptappudakimport();
	
}//end func

async function insertdocumlist(e, col){
}//end func

async function makevchrpdffile(e, doc){
	//e.preventDefault();

	e.target.style.visibility='hidden';
	
	let PAID_AMT=doc.PAID_AMT.toString().match(/[0-9].*/g);
	PAID_AMT=PAID_AMT.length?PAID_AMT[0]:PAID_AMT;
	
	let PAID_DATE=doc.PAID_DATE??"";
	
	const params={
		DOC_NO: doc.DOC_NO
		, PAID_AMT: PAID_AMT
		, PAID_DATE: PAID_DATE.toString().replaceAll('.','-').toUpperCase()
			};
	
	console.log("makevchrpdffile: "+JSON.stringify(params));
	const filename=doc.DOC_NO+".pdf";
	//const filename="RCP.pdf";

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,responseType: "blob"
	  ,body: JSON.stringify( params )
  };		


	await fetch(customspremurl+'rarvchrpdffile/makevchrpdffile',requestOptions)
	  .then(data => aftermakevchrpdffile(data, e, filename) )
      .catch(err => console.log(err));	

}//end func


async function aftermakevchrpdffile(res, e, filename){
	e.target.style.visibility='visible';
	
	const blob = await res.blob();
	saveAs(blob, filename);
	
}//end func

function handleChange(e){
	
	let {name, value}=e.target;


value=value.trim();

if (name=='DOC_NO'){
	value = value.replace(/\D/g,'');
	if (value.length>4)
		value=value.substring(value.length-4,value.length);
	}//end if
else if (name=='DOC_AMT')
	value = value.replace(/[^\d.-]/g, '');

	
console.log("handleChange name: "+name+' '+value);

	setCrit((prev)=>{
		return {...prev, [name]:value}	
	});
	
}//end func


function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func


async function delwptappudakimport(e, SEQ_NO){
	e.preventDefault();
	
	const confirmed=window.confirm("Remove this receipt voucher from this list?");
	if (!confirmed)
		return;
	
	const params={
		USERNAME:sessionStorage.getItem("USERNAME")
		, WPT_APP_ID: wptapp.WPT_APP_ID
		, SEQ_NO:SEQ_NO
		};
	
const requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( params )
};		

e.target.style.visibility='hidden';
setDowait({show:true});

await fetch(resturl+'rarwpform/delwptappudakimport',requestOptions)
  .then(res => res.json())
  .then(res => 	afterdelwptappudakimport(res, e) )
  .catch(err => console.log(err));	
	
}//end func	

function afterdelwptappudakimport(res, e){
e.target.style.visibility='visible';
setDowait({show:false});
	
showsnackbar("Done!");
gettblwptappudakimport();
}//end func

async function processwptappudakimport(e){
	e.preventDefault();
	
	const confirmed=window.confirm("Add these receipt voucher numbers to the application?");
	if (!confirmed)
		return;
	
const requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( {USERNAME:sessionStorage.getItem("USERNAME"), WPT_APP_ID: wptapp.WPT_APP_ID} )
};		

cssclass("btnprocess", "hidden", 1);

setDowait({show:true});

await fetch(resturl+'rarwpform/processwptappudakimport',requestOptions)
  .then(res => res.json())
  .then(res => 	afterprocesswptappudakimport(res, e) )
  .catch(err => console.log(err));	
	
}//end func	

function afterprocesswptappudakimport(res, e){
	
	setDowait({show:false});
	
	const UPDATE_COUNT=res.length?(res[0].UPDATE_COUNT??0):0;
	
	if (UPDATE_COUNT==0)
		window.alert("The update seems to have failed.");
	else{
		showsnackbar("done!");
		gettblwptappudakimport();
		}
		
	
	
}//end func	

async function searchdocum(e){
	e.preventDefault();
	
e.target.style.visibility='hidden';

const requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( crit )
};		

setArrayvoucher([]);
setDowait({show:true});

await fetch(resturl+'rarwpform/searchdocum',requestOptions)
  .then(res => res.json())
  .then(res => 	aftersearchdocum(res, e) )
  .catch(err => console.log(err));	
	
}//end func	

function aftersearchdocum(res, e){
	
setDowait({show:false});

e.target.style.visibility='visible';
//console.log("aftersearchdocum: "+JSON.stringify(res));
setArrayvoucher(res);

}//end func


  return (
    <>
	
	<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >
	Add Receipt Vouchers
	</p>
	<div align="center" >If this application has receipts that are not shown in APS (i.e. from Customer Service Counter), you can try add them here.</div>
	<div align="center" ><span style={{color:"brown",fontWeight:"bold"}} >Important</span>:  Be certain to have all receipt info before you start, because you might not be able to add receipts afterwards.</div>
<form id="form1" method="POST" onSubmit={(e)=>{searchdocum(e);}} >	
<table align='center' width="45%" style={{marginTop:"10px", marginBottom:"10px"}} cellSpacing="0" cellPadding="0" >
<tbody>
	<tr>
	<td align='right' >Last 4 Digits of Document No:&nbsp;</td>
	<td align='left' ><input name='DOC_NO' type="text"  value={crit.DOC_NO} required onChange={(e)=>{handleChange(e);}} autoComplete="off" onFocus={(e)=>{e.target.select();}} placeholder='Document # Last 4 Digits' /></td>
	</tr>
	<tr>
	<td align='right' >Document Date:&nbsp;</td>
	<td align='left' ><input name='DOC_DATE' type="date" value={crit.DOC_DATE} required onChange={(e)=>{handleChange(e);}} autoComplete="off" onFocus={(e)=>{e.target.select();}} placeholder='Document  Date' /></td>
	</tr>
	<tr>
	<td align='right' >Document Amount:&nbsp;</td>
	<td align='left' ><input name='DOC_AMT' type="text" value={crit.DOC_AMT} required onChange={(e)=>{handleChange(e);}} autoComplete="off" onFocus={(e)=>{e.target.select();}} placeholder='Document Amount' /></td>
	</tr>
	<tr>
	<td align='right' >Part of Customer Name:&nbsp;</td>
	<td align='left' >
		<select name='DOC_COMMENT' required value={crit.DOC_COMMENT} onChange={(e)=>{handleChange(e);}} placeholder='Customer Name' >
		<option value='' ></option>
		{mpenameopts} 
		</select>
	</td>
	</tr>
	<tr>
	<td align='right' ><a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); navigate("/wptform",{state:{WPT_APP_ID: wptapp.WPT_APP_ID}});}} ><img src="img/return.png" border="0" /> return to application</a>&nbsp;&nbsp;</td>
	<td align='left' ><button className="button" >search</button></td>
	</tr>


</tbody>
</table>
</form>
	
	<div align='center' >Search results Table</div>
	<table align='center' className='customers' style={{width:"85%"}} >
	<thead>
	<tr>
		<th>#</th>
		<th>CREATED</th>
		<th>DOC #</th>
		<th>AMOUNT</th>
		<th>DT PAID</th>
		<th>ACCOUNT</th>
		<th>COMMENT</th>
		<th>OTHER PARTY</th>
		{/*<th>COMMENT</th>*/}
	</tr>
	</thead>
	<tbody>
		{dowait.show==true && <tr><td align="center" colSpan="8" ><span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span></td></tr>}
		{dowait.show==false && tblvoucher}
	</tbody>
	</table>



	{
	tblwptappudakimport.length>0 && <>
	<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >
	Receipt Vouchers to Add to Application
	</p>
	<table align='center' className='customers' style={{width:"65%"}} >
	<thead>
	<tr>
		<th>#</th>
		<th>CREATED</th>
		<th>DOC #</th>
		<th>AMOUNT</th>
		<th>PAYMENT</th>
		<th>COMMENT</th>
		<th>TIME ADDED TO APP</th>
	</tr>
	</thead>
	<tbody>
		{tblwptappudakimport}
	</tbody>
	</table>
	<div align='center' style={{marginTop:"9px"}} >
	<button className='button' id="btnprocess" onClick={(e)=>{processwptappudakimport(e);}}  >add receipt vouchers to application</button>
	</div>
	</>
	}

<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default Rendervoucher;